var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',{class:['zg-product-icon', {
    [`zg-product-icon--size-${_vm.size}`]: _vm.size
  }]},[(_vm.product)?_c(_vm.product,{tag:"component"}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }